import React, {Component} from 'react';
import {pdfjs} from 'react-pdf';
import { Document, Page } from 'react-pdf';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleLeft} from '@fortawesome/pro-light-svg-icons/faAngleLeft';
import {faAngleRight} from '@fortawesome/pro-light-svg-icons/faAngleRight';
import LangContext from "../providers/LangContext";
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class PdfViewer extends Component {
    static contextType = LangContext;

    constructor(props) {
        super(props);
        this.state = {
            numPages: null,
            pageNumber: 1,
            minHeight: 'inherit'
        };
        this.onDocumentLoad = this.onDocumentLoad.bind(this);
        this.prev = this.prev.bind(this);
        this.next = this.next.bind(this);
        this.renderSuccess = this.renderSuccess.bind(this);
    }

    onDocumentLoad({numPages}) {
        this.setState({numPages});
    }

    prev() {

        if (this.state.pageNumber <= 1) {
            this.setState({pageNumber: this.state.numPages})
        } else {
            this.setState({pageNumber: this.state.pageNumber - 1})
        }

    }

    renderSuccess() {
        const height = document.getElementById('pdfHolder').clientHeight;
        this.setState({minHeight: height})
    }

    next() {

        if (this.state.pageNumber >= this.state.numPages) {
            this.setState({pageNumber: 1})
        } else {
            this.setState({pageNumber: this.state.pageNumber + 1})
        }

    }

    render() {
        const {pageNumber, numPages} = this.state;
        let lang = this.context.lang;
        return (
            <div className="pdf-embed row">

                <div className="col-12 text-right">
                    <div className="mb-2">
                        <div className="d-lg-inline-flex" style={{textAlign: "center", display: 'inline-flex'}}>
                            <a role="button" className="btn btn-primary mr-2 btn-brochure" style={{color: 'white', fontSize: '0.9rem', height: '33px'}} target="_blank" download href={this.props.pdfUrl}>{lang.get('sites.download_action')}</a>
                            <div onClick={this.prev} className="btn btn-primary btn-brochure" style={{
                                marginRight: '10px',
                                width: '33px',
                                height: '33px',
                                fontSize: '0.7rem',
                            }}>
                                <FontAwesomeIcon size="2x" icon={faAngleLeft}/>
                            </div>
                            <div style={{color: 'black' , height: '33px',padding: '0.2rem 0'}}>
                                <h4>{pageNumber} / {numPages}</h4>
                            </div>
                            <div onClick={this.next} className="btn btn-primary btn-brochure" style={{
                                marginLeft: '10px',
                                width: '33px',
                                height: '33px',
                                fontSize: '0.7rem',
                            }}>
                                <FontAwesomeIcon size="2x" icon={faAngleRight}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pdfHolder" style={{'minHeight': this.state.minHeight}}>
                    <Document
                        file={this.props.pdfUrl} renderAnnotations={false} renderAnnotationLayer={false}
                        onLoadSuccess={this.onDocumentLoad}>
                        <Page onRenderSuccess={this.renderSuccess} scale={2} pageNumber={pageNumber} renderAnnotations={false}
                              renderAnnotationLayer={false}/>
                    </Document>
                </div>
            </div>
        )
    }
}

export default PdfViewer;
